<template>
  <div class="modal z-50" role="dialog" :class="showModal ? 'modal-open' : ''">
    <div class="w-full h-full flex justify-center items-center flex-col bg-black/50 backdrop-blur-md px-4">
      <div class="w-full max-w-2xl rounded-md bg-woodsmoke-850 backdrop-blur-xl grid grid-cols-1 grid-rows-[auto_1fr_auto_auto] max-h-[96vh] sm:max-h-[90vh] overflow-y-auto ">
        <div class="px-4 pt-4 flex justify-between items-center">
          <div>
            <div class="flex justify-start items-center">
              <p class="text-xl">OXI Staking</p>

              <div>
                <VDropdown :shown="isOpen" placement="right">
                  <!-- This will be the popover reference (for the events and position) -->
                  <!-- <button>Click me</button> -->

                  <button @click="showTour()" class="btn btn-xs btn-square ml-2 text-lg bg-gradient-to-br from-turquoise-500/50 to-turquoise-900/50 text-turquoise-500">
                    <!-- <span class="iconify" data-icon="memory:help"></span> -->
                    <Icon name="memory:help" />
                  </button>

                  <!-- This will be the content of the popover -->
                  <template #popper>
                    <div class="p-1 px-4 bg-white text-woodsmoke-600 font-bold border border-white/20 rounded-lg">
                      <p>Press here for a tour!</p>
                    </div>
                  </template>
                </VDropdown>
              </div>
            </div>
          </div>

          <button @click="closeModal()" class="btn btn-circle text-lg btn-sm text-error bg-red-500/20 border-red-500/30">
            <!-- <span class="iconify" data-icon="mdi:close"></span> -->
            <Icon name="mdi:close" />
          </button>
        </div>

        <div class="w-full p-4 pb-0">
          <div class="w-full bg-white/5 border border-white/5 rounded-md py-2">
            <div class="w-full flex justify-between items-start px-2 mb-4">
              <div>
                <!-- <p class="text-xs text-turquoise-500 uppercase tracking-widest">Staked</p>
                  <p class="font-sans-serif text-lg">100 OXI</p> -->

                <!-- {{  tierFlyout }} -->
              </div>

              <div id="tier_flyout" class="flex justify-start space-x-4 border px-2 p-1 pr-4 border-white/5 bg-white/5 rounded-md">
                <div class="text-sm text-woodsmoke-400" v-if="stakedAmount + oxbStakeInput == 0">No Tiers</div>

                <div v-if="tierFlyout.one != 0 || tierFlyout.one_changes != 0" class="flex justify-start items-center space-x-1">
                  <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[1.5rem] h-[1.5rem]" />

                  <div class="">{{ tierFlyout.one }}</div>
                  <div class="flex justify-start items-center flex-shrink-0 text-green-500 font-bold" v-if="tierFlyout.one_changes > 0 && tierFlyout.one_changes != 0">+ {{ tierFlyout.one_changes }}</div>
                  <div class="flex justify-start items-center flex-shrink-0 text-red-500 font-bold" v-if="tierFlyout.one_changes < 0 && tierFlyout.one_changes != 0">- {{ tierFlyout.one_changes * -1 }}</div>
                </div>

                <div v-if="tierFlyout.two != 0 || tierFlyout.two_changes != 0" class="flex justify-start items-center space-x-1">
                  <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[1.5rem] h-[1.5rem]" />

                  <div class="">{{ tierFlyout.two }}</div>
                  <div class="flex justify-start items-center flex-shrink-0 text-green-500 font-bold" v-if="tierFlyout.two_changes > 0 && tierFlyout.two_changes != 0">+ {{ tierFlyout.two_changes }}</div>
                  <div class="flex justify-start items-center flex-shrink-0 text-red-500 font-bold" v-if="tierFlyout.two_changes < 0 && tierFlyout.two_changes != 0">- {{ tierFlyout.two_changes * -1 }}</div>
                </div>

                <div v-if="tierFlyout.three != 0 || tierFlyout.three_changes != 0" class="flex justify-start items-center space-x-1">
                  <img src="https://oxbull-presale.s3.amazonaws.com/tier3.svg" alt="" class="w-[1.5rem] h-[1.5rem]" />

                  <div class="">{{ tierFlyout.three }}</div>
                  <div class="flex justify-start items-center flex-shrink-0 text-green-500 font-bold" v-if="tierFlyout.three_changes > 0 && tierFlyout.three_changes != 0">+ {{ tierFlyout.three_changes }}</div>
                  <div class="flex justify-start items-center flex-shrink-0 text-red-500 font-bold" v-if="tierFlyout.three_changes < 0 && tierFlyout.three_changes != 0">- {{ tierFlyout.three_changes * -1 }}</div>
                </div>
              </div>
            </div>

            <div class="w-full flex justify-center items-center -mt-6 ">
              <div class="w-full mb-2">
                <!-- <StakingProgressBar @select-tier="selectTier" ref="progressBarRef" :staked="stakedAmount" :amount="oxbStakeInput" :tiers="tiers"></StakingProgressBar> -->
                <!-- <StakeProgressBar></StakeProgressBar> -->

                <Splide ref="splideEl" :options="{ rewind: true, pagination: false, arrows: false, autoWidth: true, padding: 0, gap: 0, speed: 1000, autoHeight:true }">
                  <SplideSlide style="border: 0" v-for="tier in tiers">
                    <StakeTierIcon @select-tier="selectTier" :key="tier.amount" :amount="tier.amount" :tiers="tier.tiers" :stakeInput="oxbStakeInput" :prev="tier.prev" :staked="stakedAmount"></StakeTierIcon>
                  </SplideSlide>
                </Splide>
              </div>
            </div>

            <!-- <div class="w-full flex justify-between items-end p-2">
                <div>
                  <div class="text-lg">50%</div>
                  <p class="text-xs uppercase tracking-wider">25 More OXI to Tier 1</p>
                </div>

                <div class="flex justify-center items-end flex-col">
                  <button class="btn btn-xs btn-link text-turquoise-500 capitalize">Stake 25 OXI</button>
                </div>
              </div> -->

            <!-- <div class="w-full h-2 bg-white/5 flex justify-start items-center">
                <div :class="['bg-turquoise-500 h-2', `w-[${50}%]`]"></div>
              </div> -->

            <!--<div class="w-full border-b border-b-white/30 px-8 mt-8">
              <p>OXI Tokens to Stake</p>
              <input placeholder="enter amount to stake" class="text-2xl m-0 p-0 w-full bg-transparent border-none placeholder:italic placeholder:text-xl" type="number" />
            </div>-->
          </div>

          <div class="w-full flex justify-between items-center">
            <div id="stake_modal_current_balance" class="pl-2">OXI in your wallet: {{ Number(oxbBalance).toFixed(2) }} OXI</div>
            <a :href="buy_oxb_url" target="_blank" id="buy_oxb_button" class="btn btn-link text-turquoise-500 capitalize">Buy OXI</a>
          </div>
        </div>

        <div v-if="!showMobileLayout" class="w-full border-b border-b-white/30 px-6 pb-2 hidden sm:grid grid-cols-[1fr_auto_2fr_auto_1fr] justify-center items-center text-center">
          <div id="stake_modal_staked_amount" class="flex justify-center items-center flex-col">
            <p class="text-sm">Staked</p>
            <p class="text-xl text-white">{{ stakedAmount }}</p>
          </div>

          <div class="row-span-2 flex justify-center items-center text-xl w-full h-full px-4">
            <p>+</p>
          </div>

          <div id="stake_modal_stake_input" class="flex justify-center items-center flex-col">
            <p class="text-sm">Enter amount of OXI To Stake</p>
            <input @input="updateProgressBar" v-model="oxbStakeInput" placeholder="enter amount to stake" class="sm:text-lg m-0 p-1 noArrow w-full text-white bg-white/5 text-center rounded-xl border-none placeholder:italic sm:placeholder:text-xl placeholder:text-sm" type="number" />
          </div>

          <div class="row-span-2 flex justify-center items-center text-xl w-full h-full px-4">
            <p>=</p>
          </div>

          <div id="stake_modal_stake_total" class="flex justify-center items-center flex-col">
            <p class="text-sm">Total</p>
            <p class="text-xl text-white">{{ stakedAmount + oxbStakeInput }}</p>
          </div>
        </div>
        

        <div v-if="showMobileLayout" class="w-full px-2">
          <div id="stake_modal_staked_amount" class="bg-white/5 p-2 rounded-lg">
            <p class="text-woodsmoke-100 text-sm">OXI Staked</p>
            <p class="text-xl font-light text-white">{{ stakedAmount }} OXI</p>
          </div>

          <div class="w-10 h-10 rounded-full bg-woodsmoke-700 flex justify-center items-center -mt-2 ml-2 z-20 relative">
            <p class="text-2xl">+</p>
          </div>

          <div class="bg-white/5 p-4 rounded-lg -mt-4 pt-5">
            <p class="text-woodsmoke-100 text-sm mb-2">Enter amount of OXI To Stake</p>
            <div class="w-full flex justify-start items-center space-x-2">
              <input id="stake_modal_stake_input" @input="updateProgressBar" v-model="oxbStakeInput" placeholder="enter amount to stake" class="text-2xl m-0 p-2 noArrow w-full text-white bg-white/5 rounded-md border-none placeholder:italic sm:placeholder:text-xl text-left" type="number" />

              <p>OXI</p>
            </div>
          </div>

          <div class="w-10 h-10 rounded-full bg-woodsmoke-700 flex justify-center items-center -mt-2 ml-2 z-20 relative">
            <p class="text-2xl">=</p>
          </div>

          <div class="w-full pb-4">
            <div class="w-full flex justify-between items-center">
              <div id="stake_modal_stake_total" class="p-2">
                <p class="text-woodsmoke-100 text-sm">Total</p>
                <p class="text-2xl font-light text-white">{{ stakedAmount + oxbStakeInput }} OXI</p>
              </div>

              <button @click="confirmStake()" :disabled="disableStakeButton" id="stake_button" class="disabled:bg-turquoise-500 disabled:opacity-20 disabled:text-turquoise-900 btn text-lg px-8 bg-turquoise-500 rounded-full text-turquoise-1000 hover:text-white">Stake</button>
            </div>

            <p class="text-red-500 text-center animate-pulse" v-if="errorMessage">{{ errorMessage }}</p>
          </div>
        </div>

        <div v-if="!showMobileLayout"  class="w-full p-4">
          <p class="text-red-500 text-center animate-pulse" v-if="errorMessage">{{ errorMessage }}</p>

          <button @click="confirmStake()" :disabled="disableStakeButton" id="stake_button" class="disabled:bg-turquoise-500 disabled:opacity-20 disabled:text-turquoise-900 btn w-full bg-turquoise-500 text-turquoise-1000 hover:text-white">Stake</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, toRefs } from "vue";
import { parseEther } from "viem";

const props = defineProps(["address", "accountData", "oxbBalance"]);
const { address, accountData, oxbBalance } = toRefs(props);

import { stakeABI } from "~/components/Stake/stakeConstants";

import { useScreens } from "vue-screen-utils";
import { useUserStore } from "@/stores/user";

const userStore = useUserStore();

import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/vue-splide/css";


import { OXB_V2_ADDRESS, STAKE_ADDRESS } from "~/wagmiConfig.js";
import { readContract, writeContract, waitForTransactionReceipt } from "@wagmi/core";

const toast = useToast();

const { $wagmiConfig } = useNuxtApp()


const _toast = (param) => {
  toast.add({
    ...param,
    ui: {
      strategy: "override",
      icon: {
        base: "flex-shrink-0 w-5 h-5 mt-0.5",
        color: "text-{color}-500 dark:text-{color}-400",
      },
      background: "bg-woodsmoke-800/50 backdrop-blur-md",
      container: "border border-turquoise-500/20 relative overflow-hidden",
      title: "text-turquoise-500 text-base",
      description: "text-white text-sm",
    },
  });
};



const { mapCurrent } = useScreens();
const showMobileLayout = mapCurrent({
  xs: true,
  sm: false,
  md: false,
  lg: false,
  xl: false,
});

// const stakedAmount = ref(9000);
// const oxbStakeInput = ref(0);
const oxbStakeInput = ref(null);

const progressBarRef = ref(null);

const tiers = ref([]);

const isOpen = ref(false);

import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { erc20Abi } from "viem";

const emit = defineEmits(["complete"]);

const stakedAmount = computed(() => {
  // let _stake = userData.value?.oxb_amount || 0;
  // return _stake / 1e18;
  return Number(accountData.value?.stakes?.amount || 0);
});

// const buy_oxb_url = "https://pancakeswap.finance/swap?outputCurrency=0x7536c00711E41df6aEBCCa650791107645b6bc52";
const buy_oxb_url = "https://app.uniswap.org/swap?outputCurrency=0x07fb80f7A8460DE3065d74B2663ba0D740fB3cA5&chain=base";

const showTour = () => {
  isOpen.value = false;

  // get the active slide index
  // console.clear()
  // console.log(progressBarRef.value.splideEl.index)

  let currentIndex = progressBarRef.value.splideEl.index;
  let tierInfoButtons = document.getElementsByClassName("tier_detail_info_button");
  let activeTierInfoButton = tierInfoButtons[currentIndex + 2];

  let tierSelectButtons = document.getElementsByClassName("tier_select_button");
  let activeTierSelectButton = tierSelectButtons[0];

  // console.log(tierInfoButtons);
  const driverObj = driver({
    showProgress: true,
    steps: [
      // { element: "#stake_modal_staked_amount",},
      { element: "#stake_modal_staked_amount", popover: { title: "Staked Amount", description: `This is the amount you've currently staked.` } },
      { element: "#stake_modal_stake_input", popover: { title: "Stake Input", description: `Enter the amount you want to stake here.` } },
      { element: "#stake_modal_current_balance", popover: { title: "OXI Balance", description: `This is the amount of OXI tokens you have in your wallet available to stake.` } },
      { element: "#buy_oxb_button", popover: { title: "Buy OXI", description: `Click here to buy more OXI tokens.` } },

      { element: "#stake_modal_stake_total", popover: { title: "Total", description: `This is the total to be. Tiers are determined based on this amount.` } },
      { element: "#tier_flyout", popover: { title: "Tier Changes", description: `The final changes to your tier will be shown in here as you update the amount to stake` } },

      { element: activeTierInfoButton, popover: { title: "Tier Info", description: `You can check the details of each tier here.`, side: "bottom", align: "end" } },
      { element: activeTierSelectButton, popover: { title: "Select Tier", description: `Click here to select this tier, we will calculate and apply the required OXI token as input.`, side: "bottom", align: "end" } },
      {
        popover: {
          description: `<div class='flex flex-col justify-center items-center space-y-2'>
          
          
          <div class='flex flex-col justify-center items-center space-y-2 p-2 rounded-xl bg-woodsmoke-800'>
            <div class="flex justify-center items-center relative">
            <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[5rem] h-[5rem]" />
            <div v-if="tiers?.one > 1" class="h-6 w-6 absolute bottom-1 right-1 bg-black/80 text-white backdrop-blur-sm ring ring-yellow-500/50 border border-yellow-500 rounded-full flex justify-center items-center font-sans-serif z-40">2</div>
          </div>

          <div class='text-white text-center'>
            <p>2 x Tier 1</p>
          <p class='text-sm text-woodsmoke-300'>16000 OXI </p>
          </div>
          
          </div>


        <p>In cases where you have more than 8000 OXI, you will start to experience multiple tiers. As shown in above example, this means you have 2 Oxbull Tier One, when you have 16000 OXI.</p>
        
        
        
        </div>`,
        },
      },
      { element: "#stake_button", popover: { title: "Stake", description: `When you're ready to stake, click here.`, side: "bottom", align: "center" } },

      // { element: '#tour-example', popover: { title: 'Animated Tour Example', description: 'Here is the code example showing animated tour. Let\'s walk you through it.', side: "left", align: 'start' }},
      // { element: 'code .line:nth-child(1)', popover: { title: 'Import the Library', description: 'It works the same in vanilla JavaScript as well as frameworks.', side: "bottom", align: 'start' }},
      // { element: 'code .line:nth-child(2)', popover: { title: 'Importing CSS', description: 'Import the CSS which gives you the default styling for popover and overlay.', side: "bottom", align: 'start' }},
      // { element: 'code .line:nth-child(4) span:nth-child(7)', popover: { title: 'Create Driver', description: 'Simply call the driver function to create a driver.js instance', side: "left", align: 'start' }},
      // { element: 'code .line:nth-child(18)', popover: { title: 'Start Tour', description: 'Call the drive method to start the tour and your tour will be started.', side: "top", align: 'start' }},
      // { element: 'a[href="/docs/configuration"]', popover: { title: 'More Configuration', description: 'Look at this page for all the configuration options you can pass.', side: "right", align: 'start' }},
      // { popover: { title: 'Happy Coding', description: 'And that is all, go ahead and start adding tours to your applications.' } }
    ],
  });

  driverObj.drive();
};

const getTiers = (amount) => {
  let tiers = {
    one: 0,
    two: 0,
    three: 0,
  };

  // Tier Three check at the beginning
  if (amount < 1000) {
    tiers.three = amount >= 50 ? 1 : 0;
    return tiers;
  }

  // Calculate Tier One
  tiers.one = Math.floor(amount / 8000);
  let remainingAmount = amount % 8000;

  // console.log(amount, remainingAmount)

  // Calculate Tier Two
  if (remainingAmount >= 1000) {
    if (remainingAmount >= 4000) {
      // If remainder after dividing by 4000 is more than 1000, add two Tier Twos
      tiers.two = remainingAmount % 4000 >= 1000 ? 2 : 1;
    } else {
      // One Tier Two for amounts between 1000 and 4000
      tiers.two = 1;
    }
  }

  return tiers;
};

const generateCorrectedCheckpoints = (totalPoints) => {
  const checkpoints = [0];
  let runningTotal = 0;
  let currentThreshold = 1000;

  if (totalPoints < 50) {
    return [0, 50, 1000, 5000, 8000];
  } else {
    if (totalPoints >= 50) {
      checkpoints.push(50);
      // runningTotal = 50;
    }

    while (runningTotal <= totalPoints || runningTotal % 8000 !== 0) {
      //   console.log(runningTotal, "RUN", currentThreshold, "THRESHOLD");

      runningTotal += currentThreshold;
      // if ((runningTotal) <= totalPoints) {
      //     checkpoints.push((runningTotal));
      // }

      checkpoints.push(runningTotal);

      // Change the threshold based on the current value
      if (runningTotal <= 8000) {
        if (currentThreshold === 1000) {
          currentThreshold = 4000;
        } else if (currentThreshold === 4000) {
          currentThreshold = 3000;
        } else if (currentThreshold === 3000) {
          currentThreshold = 1000;
        }
      } else {
        if (currentThreshold === 1000) {
          currentThreshold = 4000;
        } else if (currentThreshold === 4000) {
          currentThreshold = 3000;
        } else if (currentThreshold === 3000) {
          currentThreshold = 1000;
        }
      }
    }

    // console.log(runningTotal, "RUN")

    // we should always add one incomplete level at the end
    // runningTotal += currentThreshold;
    // checkpoints.push( runningTotal );

    // return checkpoints.map(checkpoint => {
    //     // return { checkpoint, tiers: getTiers(checkpoint) };
    //     return checkpoint

    // });

    return checkpoints;
  }
};

const renderTiers = () => {
  let _tiers = [];

  let amountToBe = oxbStakeInput.value + stakedAmount.value;

  const checkpoints = generateCorrectedCheckpoints(amountToBe);
  for (let i = 0; i < checkpoints.length; i++) {
    _tiers.push({
      amount: checkpoints[i],
      tiers: getTiers(checkpoints[i]),
      prev: checkpoints[i - 1] ? checkpoints[i - 1] : 0,
    });
  }

  //   console.log(_tiers)

  if (tiers.value.length == 0) {
    tiers.value = _tiers;
  } else if (_tiers.length < tiers.value.length) {
  } else {
    for (let i = 0; i < _tiers.length; i++) {
      if (_tiers[i]?.amount != tiers.value[i]?.amount) {
        tiers.value.push(_tiers[i]);
      }
    }
  }

  // progressBarRef.value.renderSplide();
  renderSplide();

  //   setTimeout( () => {

  //     /// loop in descending order, find the tiers where amount < tier.amount, then go to that slide - 1
  //     let amountToBe = oxbStakeInput + stakedAmount
  //     console.log("ATB", amountToBe)
  //     for(let i = tiers.value.length - 1; i >= 0; i--){
  //       if( amountToBe < tiers.value[i].amount){
  //         if(i -2 >= 0) splideEl.value.go( i - 2 );
  //         else progressBarRef.value.splideEl.go( i - 1 );
  //       }
  //     }

  //     // splideEl.value.go( tiers.value.length - 1 );
  //   }, 300)

  // console.clear()
  // console.log(tiers.value)
};

/// Splide

const splideEl = ref(null);

const renderSplide = () => {
  setTimeout(() => {
    /// loop in descending order, find the tiers where amount < tier.amount, then go to that slide - 1
    let amountToBe = oxbStakeInput.value + stakedAmount.value;
    // console.log("ATB", amountToBe);
    for (let i = tiers.value.length - 1; i >= 0; i--) {
      if (amountToBe < tiers.value[i].amount) {
        if (i - 2 >= 0) splideEl.value.go(i - 2);
        else splideEl.value.go(i - 1);
      }
    }

    // splideEl.value.go( tiers.value.length - 1 );
  }, 300);
};

const tierFlyout = ref({
  one: 0,
  two: 0,
  three: 0,
  one_change: 0,
  two_change: 0,
  three_change: 0,
});

const updateProgressBar = () => {
  //   console.log("##")
  //   progressBarRef.value.renderTiers()
  renderTiers();

  let stakedTiers = getTiers(stakedAmount.value);
  let stakeInputTiers = getTiers(oxbStakeInput.value + stakedAmount.value);

  let final = stakedTiers;

  final.one_changes = stakeInputTiers.one - stakedTiers.one;
  final.two_changes = stakeInputTiers.two - stakedTiers.two;
  final.three_changes = stakeInputTiers.three - stakedTiers.three;

  // console.log(stakedTiers, stakeInputTiers)

  // return final;
  tierFlyout.value = final;
};

const showModal = ref(false);

const closeModal = () => {
  showModal.value = false;
  oxbStakeInput.value = null;
  updateProgressBar();
};

const selectTier = (tier) => {
  // console.log(tier)
  oxbStakeInput.value = tier - stakedAmount.value;
  updateProgressBar();
};

const errorMessage = ref(null);

const disableStakeButton = computed(() => {
  errorMessage.value = null;

  if (oxbStakeInput.value > oxbBalance.value) {
    errorMessage.value = "Insufficient OXI balance";
    return true;
  }

  if (oxbStakeInput.value == null || oxbStakeInput.value == 0) return true;
  else return false;
});


const estimateETHFee = async () => {
  try {
    const _fee = await readContract($wagmiConfig, {
      abi: [
        {
          inputs: [],
          name: "getCurrentFee",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
      ],
      address: STAKE_ADDRESS,
      functionName: "getCurrentFee",
    });

    const etherFee = Number(_fee);
    // const scaleFactor = 10000;
    // const roundedNumber = Math.ceil(etherFee * scaleFactor) / scaleFactor;
    // return roundedNumber;
    return etherFee;
  } catch (error) {
    console.log(error);
    return parseEther("0.05");
  }
};

const confirmStake = async () => {
  // console.clear();

  userStore.pauseUI = true;

  // check allowance
  // use Wagmi

  let success = false;
  let hash;



  try {
    const allowanceResult = await readContract($wagmiConfig, {
      abi: erc20Abi,
      address: OXB_V2_ADDRESS,
      functionName: "allowance",
      args: [address.value, STAKE_ADDRESS],
    });

    if( (Number(allowanceResult) / 1e18 )< oxbStakeInput.value){
      // approve OXB
      const approveResult = await writeContract($wagmiConfig, {
        abi: erc20Abi,
        address: OXB_V2_ADDRESS,
        functionName: "approve",
        args: [STAKE_ADDRESS,  Math.floor(oxbStakeInput.value * 1e18)],
      });

      
      const approveReceipt = await waitForTransactionReceipt($wagmiConfig, {
        hash: approveResult,
        confirmations: 2, 
      });

      _toast({
        id: "approve",
        title: "Approved!",
        description: "Your approval has been successful.",
        timeout: 5000,
      });

    }


    const fee = await estimateETHFee();
    const stakeResult = await writeContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "stake",
      args: [ Math.floor(oxbStakeInput.value * 1e18)],
      value: fee,
      chainId: 8453,
    });

    const stakeTransactionReceipt = await waitForTransactionReceipt($wagmiConfig,{
      hash: stakeResult,
      confirmations: 2, 
    });

    _toast({
      id: "stake",
      title: "Staked!",
      description: "You've successfully staked",
      timeout: 5000,
    });

    // console.log(stakeTransactionReceipt);

    userStore.pauseUI = false;


    emit("complete", {
      hash: stakeResult,
      stake_input: oxbStakeInput.value,
      tiers: getTiers(oxbStakeInput.value + stakedAmount.value),
    });

    let totalStakes = oxbStakeInput.value + stakedAmount.value
    let tierKey = totalStakes >= 8000 ? "tier1" : totalStakes >= 1000 ? "tier2" : totalStakes >= 50 ? "tier3" : "no_tier";
    dataLayer.push({
      event: "stake",
      page: window.location.pathname,
      tier_key: tierKey,
    });

    closeModal();

  }
  catch(e){
    console.log(e);
  }

  userStore.pauseUI = false;



  // alert("Stake button clicked");
  // let tx_receipt = await walletStore.stake(oxbStakeInput.value, {
  //   get_receipt: true,
  //   auto_close_blocker: true,
  // });

  // console.log(tx_receipt);
  // if (tx_receipt?.transactionHash) {
  //   await walletStore.getStakeAmount();
  //   walletStore.refreshBalance();

  //   emit("complete", {
  //     hash: tx_receipt?.transactionHash,
  //     stake_input: oxbStakeInput.value,
  //     tiers: getTiers(walletStore.stakeAmtEtherNumber),
  //   });

  //   // setTimeout( () => {
  //   //   closeModal()
  //   // }, 500)
  // }

  
};



defineExpose({
  showModal,
  oxbStakeInput,
  updateProgressBar,
});

onMounted(() => {
  updateProgressBar();

  watch(showModal, (val) => {
  if (val) {
    setTimeout(() => {
      isOpen.value = true;
    }, 300);

    setTimeout(() => {
      //   console.log("##")
      //   progressBarRef.value.renderTiers()
      // renderTiers();
      isOpen.value = false;
    }, 3300);
  } else {
    isOpen.value = false;
  }

  updateProgressBar();
});

});
</script>

<style scoped>
.noArrow::-webkit-outer-spin-button,
.noArrow::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.noArrow[type="number"] {
  -moz-appearance: textfield;
}

.v-popper__arrow-outer {
  display: none !important;
}
</style>
